module.exports = __webpack_public_path__ + "static/media/how-to-properly-store-spices.4d284dac.jpg";